<template>
  <div class="index">

    <div class="choose-list">
      <div class="choose-item" v-for="(item, index) in list">
        <div class="choose-box" @click="checkId(item.id)">
          <img :src="`${require('@assets/images/dywfl/right-icon.png')}`" alt="" v-if="item.id==check_id">
        </div>
        <div>{{item.title}}</div>
      </div>
    </div>

    <div class="confirm-btn" @click="goPage('/social/serve/form?id='+check_id)"> 确定 </div>
  </div>
</template>

<script>
import {getPid} from "@api/public";
export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
		id:0,
		title:'',
		check_id:0,
		list:[]
    };
  },
  watch: {

  },
  mounted: function () {
	  this.id=this.$route.query.id;
	  if(this.$route.query.title){
		  document.title = this.$route.query.title;
	  }
	  this.getList();
  },
  methods: {
	checkId(e){
		this.check_id=e;
	},
	getList(){
		getPid(this.id).then(res => {
			this.list=res.data
		});
	},
    goPage(url) {
		if(!this.check_id){
			return this.$dialog.error('请选择分类');
		}
		this.$router.push({ path: url });
    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #FFEDEE;
}

.choose-list{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 .3rem;
}
.choose-item {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: .1rem;
  width: calc(50% - 0.15rem);
  margin-top: .3rem;
  padding: .3rem;

  .choose-box{
    width: .36rem;
    height: .36rem;
    border: 1px solid #A1A1A1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .05rem;
    margin-right: .2rem;
    img{
      width: .25rem;
      height: .2rem;
    }
  }
}

.confirm-btn{
  position: fixed;
  left: .2rem;
  bottom: 2rem;
  background-color: #E4446E;
  color: #fff;
  width: calc(100% - 0.4rem);
  text-align: center;
  border-radius: .2rem;
  line-height: .95rem;
  
}
</style>
